import script from "./FlyingStarsComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./FlyingStarsComponent.vue?vue&type=script&setup=true&lang=ts"

import "./FlyingStarsComponent.vue?vue&type=style&index=0&id=0487d42a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0487d42a"]])

export default __exports__